import { useMemo } from 'react';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  data: {
    x: string;
    y: number;
  }[];
  name: LangType;
}

export const useLateArrivals = (): ChartProps => {
  const { getLocale } = useLang();
  const { list } = useDashboardStore();
  const data = list?.overtime_heat_map as DataType[];

  const chartData = useMemo<Partial<ChartProps>>(() => {
    if (data?.length) {
      const series = data.map((day) => ({
        name: getLocale(day.name),
        data: day.data,
      }));

      return {
        series,
        options: {
          chart: {
            type: 'heatmap',
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            heatmap: {
              radius: 8,
              colorScale: {
                ranges: [
                  { from: 0, to: 2, color: '#FFE2D8', foreColor: '#000' },
                  { from: 3, to: 6, color: '#FEA57B', foreColor: '#000' },
                  { from: 7, to: 9, color: '#FF9D8C' },
                  { from: 10, to: 13, color: '#FF593C' },
                  { from: 13, to: 100, color: '#8B050C' },
                ],
              },
            },
          },
          xaxis: {
            categories: data[0].data.map((item) => item.x),
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              align: 'left',
              offsetX: 10,
            },
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: -34,
            markers: {
              fillColors: ['#FFE2D8', '#FEA57B', '#FF9D8C', '#FF593C', '#8B050C'],
            },
          },
          grid: {
            show: false,
          },
          stroke: {
            width: 6,
          },
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, getLocale]);

  return {
    label: 'Распределение опозданий по дням и часам',
    type: 'heatmap',
    wrapped: true,
    series: chartData.series,
    options: chartData.options,
  };
};
